export default __webpack_public_path__ + "static/media/offer-icon-published.4a326271.svg";